<template>
  <div class="u-wrap">
    <div>
    <!-- <u-subsection :list="list" :current="current" @change="change"></u-subsection> -->
    <div class="u-search">
      <input placeholder="请输入要搜索的内容" v-model="keyword" class="input" />
      <div class="u-btn" @click="clickSearch1">搜索</div>
    </div>
   </div>
    <div class="u-menu-wrap" >
        <van-empty v-if="dataList.length == 0" description="暂无数据" />
       <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading"  offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
            <div style="width:100vw;">
             <xxgk-card :list="dataList"></xxgk-card>
          </div> 
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAction, postAction ,postParam } from '@/api/manage'
import uSubsection from '@/components/page/u-subsection.vue'
import xxgkCard from '@/views/common/xxgk-card.vue'
export default {
  components: {
    uSubsection,
    xxgkCard,
  },
  props:{
    code:{
      type:String,
      default:"01"
    },
    title:{
      type:String,
      default:"党务公开"
    }
  },
  data() {
    return {
      current: 0, // 预设当前项的值
      list: [{ name: '党务公开栏' }, { name: '政务公开栏' }, { name: '财务公开栏' }],
      urls:[
        '/zhshj/zzgzdwgk/pageForGzh',
        '/zhshj/zzgzcwgk/pageForGzh',
        '/zhshj/zzgzcaiwgk/pageGzh'
      ],
      url:"",
      keyword: '',
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      typeArr:['01','02','03'],//01,02,03
      type:'01',
      pageNo:0,
      finishedTxt:''
    }
  },
  created(){
    let query = this.$route.query
    this.type =  query.code || this.code;
    let title =  query.title || '三务公开';
    console.log("query",query);
    title ? document.title = title : ''
    let i = this.typeArr.indexOf(this.type)
    this.url = this.urls[i]
    this.$store.state.xxgkType = i
    this.onRefresh();

     //this.url = this.urls[i]
  },
  computed: {},
  methods: {
    change(index) {
   
       this.current = index;
       let i = Number(index);
       this.type = this.typeArr[i];
       this.onRefresh();
       
    },
    clickSearch1() {
      this.refreshing = true;
      this.onRefresh();
    },
    getData() {
      let openId = this.$store.getters.openId;
      let params = {type:this.type,pageNo:this.pageNo,title:this.keyword,openId:openId};
      // getAction('/zhshj/csqxxglxxgk/query/list/by/orgCode',params)
      getAction(this.url,params)
      .then((res) => {
           if (this.refreshing) {
              this.dataList = [];
              this.refreshing = false;
          }
        let list = res.result.records;
        this.dataList = this.dataList.concat(list);
         this.loading = false;
        if(res.result.pages <= this.pageNo){
           this.finished = true;
           if(this.pageNo!=1){
              this.finishedTxt = "暂无更多了"
            }
        }
      })
    },
      onLoad() {
        this.pageNo++
        this.getData();
   
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.finishedTxt = ""
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNo = 0;
      this.refreshing  = true;
      this.onLoad();
    },

  },
}
</script>

<style lang="less" scoped>
// @import '../../assets/less/whon-theme.less';
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

	.u-menu-wrap {
		flex: 1;
	}


.u-search {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  background-color: #eeeeef;
}

.u-btn {
  background-color: #3e78f7;
  color: #fff;
  font-size: 14px;
  padding: 2px 12px;
  line-height: 26px;
  margin-left: 12px;
  border-radius: 4px;
   flex-shrink: 0;
}

.input {
  flex: 1;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  padding-left: 8px;
  font-size: 14px;
}

::v-deep .van-pull-refresh {
   min-height:100%
}
</style>
